<template>
  <b-modal
    :visible="value"
    title="Import results"
    ok-only
    ok-title="Close"
    @change="$emit('input', $event)"
  >
    <p class="mb-3">
      <strong>{{ successCount }}</strong> imported,
      <strong>{{ failureCount }}</strong> failed
    </p>

    <div v-if="errors.length" class="csv-error-list">
      <div v-for="(err, i) in errors" :key="i" class="csv-error-row">
        Row {{ err.row }}: {{ err.message }}
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: 'PlantEquipmentCsvResultModal',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    successCount: {
      type: Number,
      default: 0,
    },
    failureCount: {
      type: Number,
      default: 0,
    },
    errors: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style scoped>
.csv-error-list {
  max-height: 260px;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 8px 12px;
}

.csv-error-row {
  font-size: 13px;
  color: #991b1b;
  padding: 4px 0;
  border-bottom: 1px solid #f3f4f6;
}

.csv-error-row:last-child {
  border-bottom: none;
}
</style>
